import React, { useEffect } from 'react';

import { Form, Input, Button } from 'antd';
import { STATUS } from '../../../../redux/constants';
import AuthLayout from '../../../../shared-components/AuthLayout';
import { Link } from 'react-router-dom';
import { LOGIN } from '../../../../routes';
import styles from './reset-password.module.sass';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword } from '../../../../redux/actions/auth';
import { changeTitle } from '../../../../redux/actions/app';
import { formatEmail } from '../../../../redux/utils/email';

const formRef = React.createRef();

function ResetPasswordForm() {
  const dispatch = useDispatch();

  const handleChange = (values) => {
    if (values?.email) {
      formRef.current.setFieldsValue({
        email: formatEmail(values.email),
      });
    }
  };

  const handleSubmit = (data) => {
    dispatch(resetPassword(data));
  };

  return (
    <Form
      ref={formRef}
      name="reset-password-form"
      layout={'vertical'}
      onFinish={handleSubmit}
      onValuesChange={handleChange}
      initialValues={{
        remember: true,
      }}
    >
      <Form.Item
        className={styles.reset_password_input}
        name="email"
        label={'Email (required)'}
        rules={[
          {
            required: true,
            message: 'Please input your Email!',
          },
          {
            type: 'email',
            message: 'Invalid email format. Enter a valid email address.',
          },
        ]}
      >
        <Input placeholder="Enter your email address" />
      </Form.Item>
      <div style={{ textAlign: 'left' }}>
        <Link className={styles['login-link']} to={LOGIN}>
          Back to Login
        </Link>
      </div>
      <Form.Item style={{ marginBottom: 0 }}>
        <Button
          type="primary"
          htmlType="submit"
          size="large"
          style={{ marginTop: 24 }}
        >
          Send
        </Button>
      </Form.Item>
    </Form>
  );
}

function ResetPassword() {
  return (
    <AuthLayout
      title={'Forgot Your Password'}
      description={
        "Enter the email associated with your account and we'll send you a reset link."
      }
    >
      <ResetPasswordForm />
    </AuthLayout>
  );
}

function ResetPasswordEmailSent() {
  return (
    <AuthLayout
      title={'Reset password email is sent'}
      description={
        <>
          We've just sent you a reset password email.
          <br />
          Please, follow the instructions on the email to reset your password
          successfully.
        </>
      }
    />
  );
}

function ResetPasswordContainer(props) {
  const passwordResetStatus = useSelector(
    (state) => state.auth.passwordResetStatus,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Forgot Password - Silent Push';
    dispatch(changeTitle('Forgot Password'));
  }, []);

  return (
    <>
      {passwordResetStatus === STATUS.SUCCESS ? (
        <ResetPasswordEmailSent />
      ) : (
        <ResetPassword />
      )}
    </>
  );
}

export default ResetPasswordContainer;
